<template>
  <span>
    <v-navigation-drawer app dark v-model="drawer">
      <v-list>
        <template v-for="(item, index) in activeItems">
          <v-list-tile
            v-if="!item.childs"
            class="grey darken-3"
            active-class="grey darken-2"
            dark
            :key="index"
            :to="item.target"
            @click="currentSection = item"
          >
            <v-list-tile-action>
              <v-icon>{{item.icon}}</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>{{$t(item.title)}}</v-list-tile-title>
          </v-list-tile>
          <v-list-group v-else :key="index" no-action>
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon>{{item.icon}}</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>{{$t(item.title)}}</v-list-tile-title>
              </v-list-tile>
            </template>
            <v-list-tile
              v-for="(subitem, i) in item.childs"
              :key="i"
              :to="subitem.target"
              active-class="grey darken-2"
            >
              <v-list-tile-title>{{$t(subitem.title)}}</v-list-tile-title>
              <v-list-tile-action>
                <v-icon>{{subitem.icon}}</v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </v-list-group>
          <v-divider :key="`divider-${index}`"></v-divider>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar app dark>
      <v-toolbar-side-icon @click="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>
        <span v-if="appTitle">{{appTitle}}</span>
        <v-progress-circular v-else indeterminate></v-progress-circular>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-progress-circular v-if="checkingAuthentication" indeterminate></v-progress-circular>
      <language-control />
    </v-toolbar>
  </span>
</template>

<script>
import { mapState } from "vuex";
import LanguageControl from "./LanguageControl";
export default {
  name: "AppNavigation",
  components: {
    LanguageControl
  },
  created() {
    console.log("AppNavigation Created");
  },
  data() {
    return {
      drawer: undefined,
      items: [
        {
          title: "menu.device-list",
          target: "/",
          icon: "view_module",
          public: true
        },
        {
          title: "menu.home",
          target: "/home",
          icon: "home"
        },
        {
          title: "menu.network",
          icon: "computer",
          target: "/network"
          /*
          childs: [
            //{ title: "Settings", target: "/network", icon: "settings" },
            { title: "menu.cabled", target: "/cabled", icon: "computer" },
            { title: "menu.wireless", target: "/wireless", icon: "wifi" }
          ]*/
        },
        {
          title: "menu.system",
          icon: "build",
          childs: [
            { title: "menu.update", target: "/update", icon: "sync" },
            { title: "menu.others", target: "/others", icon: "menu" }
          ]
        },
        /*{
          title: "Duo",
          icon: "pause",
          target: "/duo"
        },*/
        {
          title: "menu.duo",
          icon: "pause",
          childs: [
            { title: "menu.units", target: "/units", icon: "pause" },
            { title: "menu.features", target: "/features", icon: "star" },
            {
              title: "menu.settings",
              target: "/duo/settings",
              icon: "settings"
            }
          ]
        },
        {
          title: "menu.logout",
          icon: "logout",
          target: "/logout"
        },
        {
          title: "menu.help",
          target: "/help",
          icon: "help",
          public: true
        }
      ]
    };
  },
  computed: {
    appTitle: function() {
      let title = "";
      let _public = true;
      this.items.forEach(element => {
        if (element.target == "/" + this.$route.name) {
          _public = element.public;
        }
      });

      if (!_public && this.currentGateway) {
        title += this.currentGateway.id + " / ";
      }
      console.log(this.$route.name);
      if (!this.$route.name)
        return null;
      title += this.$t("menu." + this.$route.name);
      return title;
    },
    activeItems: function() {
      return this.items.filter(item => {
        if (this.isAuthenticated) return true;
        return item.public;
      });
    },
    ...mapState({
      isAuthenticated: state => state.auth.isAuthenticated,
      checkingAuthentication: state => state.auth.checking,
      currentGateway: state => state.gateways.current
    })
  }
};
</script>
<style scoped>
</style>
